<template>
    <div>
        <section class="item-image" v-if="item.type!='photo'">
            <div class="image">
                <img :src="'/item/image/'+item_id" >
            </div>
        </section>
        <photo-slider
            :item_id="item_id"
            kind='sample'
            v-if="item.type=='photo'"
        ></photo-slider>

        <section id="item-info">
            <div class="item-title">{{ item.title }}</div>
            <div class="item-date" v-if="item.on_sale_date !== undefined && item.hidden_flag != 1 && item_type_view_status == 1">{{ item.on_sale_date.replace(/-/g, '.') }}</div>
            <div class="item-type" v-for="tab in tabs" v-if="tab.type===item.type && item.hidden_flag != 1 && item_type_view_status == 1">
                {{ characters[tab.type+'_type'] }}
            </div>
            <div class="item-description">
                <span v-html="item.description" v-if="sabra_access_status==0"></span>
                <div v-if="subscription_link_flag==1" style="padding: 12px 0px;">
                    <p>{{ characters.subscription_content }}</p>
                </div>
                <section id="item-purchase" v-if="subscription_link_flag==1 && item.subscription_flag==0 && posisaloStatus && !loginStatus">
                    <div><a class="button btn btn-dark" role="button" aria-pressed="true" href="/posisalo/record/url">{{ characters.positivesalon_2 }}</a></div>
                </section>

                <section id="item-purchase" v-if="subscription_link_flag==1 && item.subscription_flag==0 && posisaloStatus">
                    <div><a class="button btn" role="button" aria-pressed="true" href="/subscription/purchase" :class="posisaloStatus?'btn-success':'btn-dark'">{{ characters.purchase_subscription }}</a></div>
                    <div class="price ml-auto" v-if="subscription_price==0 && !posisaloStatus">{{ characters.free }}</div>
                    <div class="price ml-auto" v-if="subscription_price!=0 && !posisaloStatus">{{ '￥'+subscription_price.toLocaleString() }}</div>
                </section>
            </div>
        </section>

        <div v-if="item.type==='music' || item.type==='video'">
            <div v-for="digicon in digicons">
                <section id="item-player" class="music-info screen-transition" @click="play(digicon)">
                    <div id="music-title" class="music-title">{{ digicon.title }}</div>
                    <div :class="[digicon.video_type!=0 ? 'music-trial-posi' : 'music-trial']"><img :src="getImageUrl(digicon.video_type)" class="music-trial-image"></div>
                    <div v-if="(digicon.bought_flag===0 && digicon.free_flag===0 && digicon.subscription_status==0 && digicon.sample_exist_flag===1) && digicon.video_type==0"  id="play" class="music-play-button">{{ characters.trial_play }}</div>
                    <div v-if="(digicon.bought_flag===1 || digicon.free_flag===1 || digicon.subscription_status==1) && digicon.video_type==0" id="play" class="music-play-button">{{ characters.play }}</div>
                </section>
            </div>
        </div>

        <section id="item-purchase" v-if="(item.type=='goods' && item.soldout_flag==0) || (item.type!='goods' && item.purchasable_flag==1)">
            <div><a class="button btn btn-dark" role="button" aria-pressed="true" :href="'/purchase/' + item.item_id ">{{ characters.open_purchase_page }}</a></div>
            <div class="price ml-auto" v-if="otanishinjiro_access_status!=1">{{ '￥' + item.price.toLocaleString() }}</div>
        </section>

        <section id="item-purchase" v-if="item.soldout_flag==1">
            <div><a class="button btn btn-dark" role="button" aria-pressed="true" style="color:#FFFFFF">{{ characters.out_of_stock }}</a></div>
            <div class="price ml-auto">{{ characters.soldout }}</div>
        </section>

        <section id="item-purchase" v-if="item.bought_flag==1">
            <div><a class="button btn btn-dark" role="button" aria-pressed="true" style="color:#FFFFFF">{{ characters.purchased }}</a></div>
        </section>

        <section id="item-purchase" v-if="subscription_link_flag==1 && item.subscription_flag==0 && !posisaloStatus">
            <div><a class="button btn" role="button" aria-pressed="true" href="/subscription/purchase" :class="posisaloStatus?'btn-success':'btn-dark'">{{ characters.purchase_subscription }}</a></div>
            <div class="price ml-auto" v-if="subscription_price==0">{{ characters.free }}</div>
            <div class="price ml-auto" v-if="subscription_price!=0">{{ '￥'+subscription_price.toLocaleString() }}</div>
        </section>

        <section id="item-info" v-if="sabra_access_status==1">
            <div class="item-description">
                <span v-html="item.description"></span>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: "store-detail",
        props: ['item_id', 'item_type_view_status', 'sabra_access_status', 'otanishinjiro_access_status', 'json_characters'],
        data: function () {
            return {
                tabs: [
                    {type: 'music', title: '音楽'},
                    {type: 'video', title: 'ビデオ'},
                    {type: 'goods', title: 'グッズ'},
                    {type: 'photo', title: '写真・画像'},
                    {type: 'ticket', title: 'チケット'},
                ],
                item: [],
                digicons: [],
                subscription_link_flag: 0,
                subscription_price: 0,
                characters: Object,
                posisaloStatus: false,
                loginStatus: false,
                image_urls: [
                    {id: 0, url:'/image/icons/trial_play.png'},
                    {id: 1, url:'http://cdn.ctpfs.jp/storage/EF4EC75373/image/243EBF3164770ECEC1C5AC291D92FB3644A8E40BE6BB0F77A1.png'},
                    {id: 2, url:'http://cdn.ctpfs.jp/storage/EF4EC75373/image/75519C2200D86991C31EEA66F03CE9FE4A621754BBBA5925.png'},
                    {id: 3, url:'http://cdn.ctpfs.jp/storage/EF4EC75373/image/243E90013FD8699EC3C8A124109FF63B49A5E906EBB6027AAC.png'},
                ],
            }
        },
        mounted() {
            axios.default
                .get('/store/detail/' + this.item_id)
                .then(response => {
                    this.item = response.data;
                    this.subscription_link_flag = this.item.subscription_link_flag;
                });
            axios.default
                .post('/digicon/detail/' + this.item_id)
                .then(response => {
                    this.digicons = response.data;
                });
            axios.default
                .get('/posisalo/status/login/get')
                .then(response => {
                    const res = response.data;
                    if(res.posisalo) {
                        this.posisaloStatus = true;
                    }
                    if(res.login) {
                        this.loginStatus = true;
                    }
                });
            axios.default
                .get('/subscription/info/get')
                .then(response => {
                    if(response.data) {
                        let subscription_info = response.data[0];
                        this. subscription_price = subscription_info.price;
                    }
                });
            this.characters = JSON.parse(this.json_characters);
        },
        methods: {
            play: function(digicon) {
                if(digicon.bought_flag===0 && digicon.free_flag===0  && digicon.subscription_status==0 && digicon.sample_exist_flag===1){
                    location.href = `/store/player/${digicon.digicon_id}`;
                    return;
                }
                if(digicon.bought_flag===1 || digicon.free_flag===1 || digicon.subscription_status==1) {
                    location.href = `/purchased/player/${digicon.digicon_id}?shuffle_flag=0`;
                    return;
                }
                if(!this.loginStatus) {
                    location.href = `/posisalo/record/url`;
                    return;
                }
                if(this.loginStatus && this.subscription_link_flag==1 && this.item.subscription_flag==0) {
                    location.href = `/subscription/purchase`;
                    return;
                }
            },
            getImageUrl: function(video_type) {
                const image_url = this.image_urls.find(element => element.id === video_type);
                if(image_url) {
                    return image_url.url;
                }
                return '/image/icons/trial_play.png';
            },
        }
    }
</script>

<style scoped>
</style>
